<template>
  <div class="main">
    <div class="infoFilt">
      <div class="search">
        <div class="demo-input-suffix">
          店铺名:
          <el-input v-model="input" class="searchInput" size="mini" placeholder="请输入店铺名"></el-input>
        </div>
        <input class="searchInput searchInput2" v-model="input" placeholder="输入搜索内容" />
        <el-button class="searchBtn" type="primary">查询</el-button>
      </div>
    </div>
    <div class="itemNav">
      <span>
        <el-checkbox v-model="allChecked"></el-checkbox>
      </span>
      <span>序号</span>
      <span>用户名</span>
      <span>收货地址</span>
      <span>邮箱</span>
      <span>订单</span>
      <span>消费金额 ($)</span>
      <span>店铺</span>
      <span>创建时间</span>
    </div>
    <div class="item" v-for="(item,index) in 12" :key="index">
      <span>
        <el-checkbox v-model="allChecked"></el-checkbox>
      </span>
      <span>{{ index+1 }}</span>
      <span>用户名</span>
      <span>美国加利福利亚</span>
      <span>5563045@qq.com</span>
      <span>2</span>
      <span>178</span>
      <span>店铺1</span>
      <span>2019-09-23 13: 42</span>
    </div>
    <!-- 分页 -->
    <div class="pag">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="30"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="20"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: "",
      allChecked: false,
      store: ""
    };
  }
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  padding: 0 20px;
  padding-right: 10px;
  border: none;
  box-sizing: border-box;
  .infoFilt {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 20px;
    .demo-input-suffix {
      margin-right: 10px;
    }
  }
  .search {
    display: flex;
    justify-content: flex-end;
    .searchInput {
      width: 260px;
      height: 26px;
      background: rgba(255, 255, 255, 1);
      border-radius: 3px;
      // border: 1px solid rgba(221, 224, 227, 1);
      border-radius: 0;
      padding-left: 10px;
    }
    .searchInput2 {
      border: 1px solid rgba(221, 224, 227, 1);
      border-radius: 4px 0px 0px 4px;
    }
    .searchBtn {
      height: 28px;
      line-height: 28px;
      padding: 0 12px;
      border-radius: 0px 3px 3px 0px;
    }
  }
  .total {
    width: 121px;
    height: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 12px;
    margin: 10px 0;
  }
  .itemNav,
  .item {
    padding-left: 18px;
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 16px;
    }
    span:nth-child(1) {
      width: 30px;
      display: inline-block;
      margin-right: 0;
    }
    span:nth-child(2) {
      display: inline-block;
      text-align: center;
      width: 4%;
    }
    span:nth-child(3) {
      display: inline-block;
      text-align: center;
      width: 8%;
    }
    span:nth-child(4) {
      display: inline-block;
      text-align: center;
      width: 20%;
    }
    span:nth-child(5) {
      display: inline-block;
      text-align: center;
      width: 18%;
    }
    span:nth-child(6) {
      display: inline-block;
      text-align: center;
      width: 8%;
    }
    span:nth-child(7) {
      display: inline-block;
      text-align: center;
      width: 10%;
    }
    span:nth-child(8) {
      display: inline-block;
      text-align: center;
      width: 16%;
    }
    span:nth-child(9) {
      display: inline-block;
      text-align: center;
      width: 12%;
    }
  }
  .itemNav {
    margin-bottom: 10px;
  }
  .item {
    background: rgba(246, 249, 252, 1);
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    height: 48px;
    padding: 0;
    padding-left: 18px;
    &:hover {
      background-color: #eee;
      cursor: auto;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    span:nth-child(5) {
      color: #333333;
    }
    span:nth-child(7) {
      color: #ffa000;
    }
    span:nth-child(9) {
      color: #333333;
    }
  }
  .pag {
    margin: 22px 0;
    text-align: center;
    /deep/ .btn-prev,
    /deep/ .btn-next {
      padding: 0 8px;
    }
  }
}
</style>